import React from 'react';
import './FrameworkPicker.css';

const GENRE_LABELS = {
  universal: 'Universal',
  mystery: 'Mystery',
  romance: 'Romance',
  thriller: 'Thriller',
  horror: 'Horror',
  fantasy_adventure: 'Fantasy / Adventure',
};

export function genreStandingLabel(tag) {
  if (!tag) return '';
  const named = GENRE_LABELS[tag] || String(tag).replace(/_/g, ' ');
  return named.trim().toUpperCase();
}

/**
 * Standing uppercase gold genre mark. Matches picker detail.
 * Persistent wherever the hung framework is shown — not a toast.
 */
export default function GenreStandingMark({ genre, className = '' }) {
  const label = genreStandingLabel(genre);
  if (!label) return null;
  return (
    <p className={`fw-detail__tag ${className}`.trim()} role="status">
      {label}
    </p>
  );
}
